<template>
  <div class="msgItem">
    <!-- <div class="msgIcon">
      <i :class="['iconfont',hint.icon]"></i>
    </div> -->
    <div class="msgContent">
      <div class="content">
        <span>{{hint.name}}</span>
        <p>{{isBind?hint.bind:hint.unbind}}{{msgType=='3'?'':isBind?content:''}}</p>
      </div>
      <div v-if="isBind" class="handler">
        <span><i class="iconfont icon-xuanze"></i>{{msgType==4 || msgType==5?"已设置":"已绑定"}}</span>
        <el-divider direction="vertical"></el-divider>
        <el-button type="text" @click="setType(1)" class="changeBtn">{{msgType==3?"解绑":"修改"}}</el-button>
      </div>
      <el-button v-else type="primary" size="small" @click="setType(2)">{{msgType==4?"设置密码":(msgType==5?"立即设置":"立即绑定")}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isBind", "msgType", "hint", "msgName", "content"],
  methods: {
    // 修改/绑定信息
    setType(type) {
      this.$emit("updateInfo", this.msgType, type)
    }
  }
}
</script>

<style lang="scss">
.msgItem {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 24px;
  font-family: PingFangSC, PingFang SC;
  .msgIcon {
    width: 39px;
    height: 39px;
    margin-bottom: 15px;
    background: $grayBgColor;
    border-radius: 50%;
    color: $primaryColor;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    i {
      font-size: 20px;
    }
    .icon-youxiang {
      font-size: 12px;
    }
  }
  .msgContent {
    flex: 1;
    display: flex;
    padding-bottom: 15px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $grayBorder;
    .content {
      span {
        font-size: 14px;
        font-weight: 400;
        // color: $textColor;
        color: #333;
      }
      p {
        margin-top: 9px;
        font-size: 12px;
        color: $gray;
      }
    }
    .handler {
      color: #333;
      font-size: 14px;
      i {
        font-size: 13px;
        margin-right: 6px;
        color: $green;
      }
      .changeBtn {
        font-weight: 400;
        font-family: PingFangSC, PingFang SC;
      }
    }
  }
}
</style>